// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = {
  path: "taskManagement",
  name: "taskManagement",
  component: { render: (e) => e("router-view") },
  redirect: { name: "taskManagementIndex" },
  meta: {
    title: "任务管理",
    icon: "icon-zhuye",
  },
  children: [
    {
      path: "index",
      name: "taskManagementIndex",
      component: () => import("../views/forestage/Index.vue"),
      meta: {
        title: "任务管理",
        showFoot: false,
      },
    },
    {
      path: "taskManagementManagement",
      name: "taskManagementManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/taskManagementManagement/TaskManagementManagement.vue"
        ),
      meta: {
        title: "任务创建",
        icon: "",
        showHeader: false,
        showSide: false,
      },
    },
    {
      path: "taskManagementDetail",
      name: "taskManagementDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/taskManagementDetail/TaskManagementDetail.vue"
        ),
      meta: {
        title: "任务管理预览",
        icon: "",
        layout: false,
      },
    },
    {
      path: "taskManagementFormDetail",
      name: "taskManagementFormDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/taskManagementFormDetail/TaskManagementFormDetail.vue"
        ),
      meta: {
        title: "任务管理表单详情",
        icon: "icon-quanbu",
      },
    },
  ],
};
// 后台路由
const cms_routers = undefined;
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
